<template>
	<div>
		<modalconfirm ref="modalconfirmAddPO" @action="proccessPO"/>
		<modalSchedule ref="modalSchedule" @saveSchedule="saveSchedule"/>
		<div class="text-h5">Tambah Pemesanan</div>
		<v-card class="mt-3" outlined>
			<v-form ref="formPO" role="form" v-on:submit.prevent="addPO">
				<v-card-text class="pt-2">
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="12" sm="3" md="3" class="py-0">
							<v-row>
								<v-col cols="12" md="12">
									<v-autocomplete :items="supplierResults" v-model="po_supplier" item-text="supplier_name" item-value="supplier_id" label="Supplier" no-data-text="Tidak ada data yang sesuai" @focus="() => responseError.supplier_id=''" :error-messages="responseError.supplier_id" :rules="[inputrules.required]" outlined dense>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" md="12" class="pt-0">
									<v-autocomplete :items="list_payment" v-model="po_payment" label="Tipe Pembayaran" no-data-text="Tidak ada data yang sesuai" @focus="() => responseError.payment_method=''" :error-messages="responseError.payment_method" :rules="[inputrules.required]" hide-details="auto" outlined dense>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-textarea v-model="po_note" label="Catatan" rows="3" height="120" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-alert v-if="responseError.product" color="red lighten-4 pink--text text-body-2">
								<v-icon class="mt-n1" color="pink">mdi-alert-circle-outline</v-icon>
								<span class="pl-2">{{responseError.product}}</span>
							</v-alert>
							<v-simple-table class="white-row">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="25%" class="text-left">Kode Produk</th>
											<th width="15%" class="text-left">Jumlah</th>
											<th width="10%" class="text-left">Unit</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<div class="d-flex">
													<div>
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromPO(index)">
																	<v-icon dark>mdi-delete</v-icon>
																</v-btn>
															</template>
															<span>Hapus</span>
														</v-tooltip>
													</div>
													<div class="ml-2">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-badge bordered color="error" :content="product.schedules.length" :value="product.schedules.length" overlap>
																	<v-btn :disabled="product.data.quantity == 0" fab light x-small depressed :color="product.schedules.length > 0 ? 'primary' : 'primary lighten-3'" v-bind="attrs" v-on="on" @click.stop="setSchedule(index, product.data.quantity, product.schedules, product.data.product_code)">
																		<v-icon dark v-if="product.schedules.length == 0">mdi-calendar</v-icon>
																		<v-icon dark v-else>mdi-calendar-check</v-icon>
																	</v-btn>
																</v-badge>
															</template>
															<span>Atur Jadwal</span>
														</v-tooltip>
													</div>
												</div>
											</td>
											<td>
												<v-autocomplete :items="productsNotSelected" :filter="customFilter" return-object item-text="product_name" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-3 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-autocomplete>
											</td>
											<td> {{ product.data.product_code }}</td>
											<td>
												<v-currency-field v-model="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" :outlined="true" dense hide-details="auto" background-color="white" class="py-3 details-mb-0"/>
											</td>
											<td> {{ product.data.product_unit }}</td>
										</tr>
									</tbody>
									<tfoot>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-btn light depressed color="primary" @click="addProduct" :disabled="!po_supplier">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Produk</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn :disabled="productsSelected.length == 0" depressed class="text-capitalize" color="primary darken-1" type="submit">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import { mapActions, mapState, mapMutations } from 'vuex'
import modalSchedule from '@/views/MLwarehouse/po/ModalSchedulePO'

export default {
	inject: ['theme'],
	components: {
		modalSchedule,
	},
	data() {
		return {
			dialog: false,
			menu: false,
			list_payment: ['Lunas', 'Tempo'],
			po_supplier: '',
			po_payment: '',
			productsSelected: [],
			po_note: '',
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Satuan Produk', align: 'start', value: 'product_unit', sortable: true},
			{ text: 'Jumlah Permintaan', value: 'quantity', align: 'end', width: "15%"},
			{ text: 'Action', value: 'action', sortable: false},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('po', ['supplierProducts', 'response', 'responseError', 'supplierResults', 'alertMultiple']),
		...mapState('auth', ['userData']),

		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const productSelected = this.productsSelected.map((el) => el.data)
				return this.supplierProducts.map((el) => {
					if (productSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.supplierProducts
		},
	},
	methods: {
		...mapActions('po', ['getSupplierProducts', 'createPO', 'getSupplierOption']),
		...mapMutations('po', ['saveResponse', 'clearDataPO', 'setSupplierProducts', 'validationError', 'multipleAlert']),
		...mapMutations(['setOverlay']),

		customFilter (item, queryText) {
			const textOne = item.product_code.toLowerCase()
			const textTwo = item.product_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		addProduct() {
			this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: '',
					product_name: '',
					quantity: 0,
				},
				schedules: []
			})
		},
		deletefromPO(index){
			this.productsSelected.splice(index, 1)
		},
		setSchedule(index, quantity, schedules, code) {
			this.multipleAlert([])
			this.$refs.modalSchedule.showModal(index, quantity, schedules, code)
		},
		saveSchedule(data, index) {
			this.productsSelected[index].schedules = [... data]
		},
		addPO(){
			if (this.$refs.formPO.validate()) {
				this.$refs.modalconfirmAddPO.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
				this.$refs.modalconfirmAddPO.showConfirm()
			}
		},
		async proccessPO(){
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddPO.hideConfirm()
			let product = await this.productsSelected.map( (el) => {
				return {
					product_name: el.data.product_name,
					product_id: el.data.product_id,
					quantity: el.data.quantity,
					price: el.data.price,
					schedule: el.schedules
				}
			})
			let msg = await []
			await product.forEach( el => {
				let qty = el.quantity
				let totalQty = 0
				el.schedule.forEach( el => {
					totalQty += parseInt(el.quantity)
				});
				if (qty != totalQty && totalQty > 0) {
					msg.push(`Jumlah Produk ${el.product_name} dijadwalkan tidak cocok dengan jumlah diminta`);
				}
			})
			await this.multipleAlert(msg)
			if (msg.length == 0) {
				let params = await {
					supplier_id: this.po_supplier,
					warehouse_id: this.userData.user_warehouse_id,
					payment_method: this.po_payment.toLowerCase(),
					note: this.po_note,
					product: product
				}
				await this.createPO(params).then(() => {
					if (this.response.code == 200.) {
						this.resetForm()
					}
				})
			}
			await this.setOverlay(false)
		},
		resetForm(){
			this.saveResponse({})
			this.$refs.formPO.resetValidation()
			this.productsSelected = []
			this.po_supplier = ''
			this.po_payment = ''
			this.po_note = ''
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah Pemesanan`)
		this.getSupplierOption({limit:100})
	},
	beforeDestroy() {
		this.clearDataPO()
	},
	watch: {
		po_supplier(val){
			if (val) {
				this.getSupplierProducts({supplier_id: val})
			} else {
				this.setSupplierProducts({ data: [], pagination: {} })
			}
			this.productsSelected = []
		}
	}
}
</script>